import { Component, inject, signal, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RequestService } from '../../../services/request-service';
import { openBlobInNewTab } from '../../../utils/open-blob';

@Component({
  selector: 'app-printpdf',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgOptimizedImage
  ],
  templateUrl: './printpdf.html',
  styleUrl: './printpdf.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Printpdf implements OnInit {
  private route = inject(ActivatedRoute);
  private requestService = inject(RequestService);
  private toastr = inject(ToastrService);

  imgSrc = environment.logoUrl;

  hidePassword = signal(true);
  isLoading = signal(false);

  passwordControl = new FormControl('', [Validators.required]);

  private documentId = '';

  ngOnInit(): void {
    this.documentId = this.route.snapshot.paramMap.get('documentId') ?? '';
  }

  openPdf(): void {
    if (this.passwordControl.invalid) {
      this.passwordControl.markAsTouched();
      return;
    }

    this.isLoading.set(true);

    this.requestService.getPdfForReferringRequest({
      generatedCode: this.documentId,
      password: this.passwordControl.value!
    })
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (blob) => {
          openBlobInNewTab(blob, 'diagnose.pdf');
        },
        error: () => {
          this.toastr.error('Hibás jelszó!', '', { positionClass: 'toast-top-center' });
        }
      });
  }
}
